import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'

document.addEventListener('DOMContentLoaded', function () {
    
    // Keep the logo slider functionality
    const logoSliderElement = document.querySelector('.logo-slider');
    if (logoSliderElement) {
      const logoSwiper = new Swiper('.logo-slider', {
        modules: [Autoplay, Navigation],
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 5,
          },
        }
      });

      const logoSlides = document.querySelectorAll('.logo-slide');
      logoSlides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img) {
          slide.addEventListener('mouseenter', () => {
            img.style.transform = 'scale(1.1)';
          });
          
          slide.addEventListener('mouseleave', () => {
            img.style.transform = 'scale(1)';
          });
        }
      });
    }

    // Add subtle hover effect to employer steps cards
    const employerStepCards = document.querySelectorAll('.employer-steps-container .bg-white');
    
    if (employerStepCards.length > 0) {
        employerStepCards.forEach(card => {
            card.addEventListener('mouseenter', function() {
                this.classList.add('shadow-xl');
                const img = this.querySelector('img');
                if (img) {
                    img.style.transform = 'scale(1.05)';
                    img.style.transition = 'transform 0.5s ease';
                }
            });
            
            card.addEventListener('mouseleave', function() {
                this.classList.remove('shadow-xl');
                const img = this.querySelector('img');
                if (img) {
                    img.style.transform = 'scale(1)';
                }
            });
        });
    }
});